// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ActivityFeedbackRepresentation } from './ActivityFeedbackRepresentation'
import {
  ActivityFeedbackRepresentationFromJSON,
  ActivityFeedbackRepresentationFromJSONTyped,
  ActivityFeedbackRepresentationToJSON,
} from './ActivityFeedbackRepresentation'
import type { WritingStatus } from './WritingStatus'
import {
  WritingStatusFromJSON,
  WritingStatusFromJSONTyped,
  WritingStatusToJSON,
} from './WritingStatus'

/**
 *
 * @export
 * @interface ActivityResultSnapshotRepresentation
 */
export interface ActivityResultSnapshotRepresentation {
  /**
   *
   * @type {string}
   * @memberof ActivityResultSnapshotRepresentation
   */
  activityResultSnapshotId?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultSnapshotRepresentation
   */
  uniqueWords?: number | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultSnapshotRepresentation
   */
  eventId?: string | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultSnapshotRepresentation
   */
  resultId: string
  /**
   *
   * @type {string}
   * @memberof ActivityResultSnapshotRepresentation
   */
  userId: string
  /**
   *
   * @type {string}
   * @memberof ActivityResultSnapshotRepresentation
   */
  activityId: string
  /**
   *
   * @type {string}
   * @memberof ActivityResultSnapshotRepresentation
   */
  assignmentId?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultSnapshotRepresentation
   */
  assignmentTaskId?: number | null
  /**
   *
   * @type {boolean}
   * @memberof ActivityResultSnapshotRepresentation
   */
  isQuest?: boolean
  /**
   *
   * @type {WritingStatus}
   * @memberof ActivityResultSnapshotRepresentation
   */
  status: WritingStatus
  /**
   *
   * @type {number}
   * @memberof ActivityResultSnapshotRepresentation
   */
  score?: number | null
  /**
   *
   * @type {Date}
   * @memberof ActivityResultSnapshotRepresentation
   */
  createdDate?: Date
  /**
   *
   * @type {Date}
   * @memberof ActivityResultSnapshotRepresentation
   */
  updatedDate?: Date | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultSnapshotRepresentation
   */
  reflection?: string | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultSnapshotRepresentation
   */
  words?: number | null
  /**
   *
   * @type {number}
   * @memberof ActivityResultSnapshotRepresentation
   */
  userTargetWordCount?: number | null
  /**
   *
   * @type {string}
   * @memberof ActivityResultSnapshotRepresentation
   */
  userTitle?: string | null
  /**
   *
   * @type {Array<ActivityFeedbackRepresentation>}
   * @memberof ActivityResultSnapshotRepresentation
   */
  resultFeedback?: Array<ActivityFeedbackRepresentation> | null
}

/**
 * Check if a given object implements the ActivityResultSnapshotRepresentation interface.
 */
export function instanceOfActivityResultSnapshotRepresentation(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'resultId' in value
  isInstance = isInstance && 'userId' in value
  isInstance = isInstance && 'activityId' in value
  isInstance = isInstance && 'status' in value

  return isInstance
}

export function ActivityResultSnapshotRepresentationFromJSON(
  json: any,
): ActivityResultSnapshotRepresentation {
  return ActivityResultSnapshotRepresentationFromJSONTyped(json, false)
}

export function ActivityResultSnapshotRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityResultSnapshotRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activityResultSnapshotId: !exists(json, 'activity_result_snapshot_id')
      ? undefined
      : json['activity_result_snapshot_id'],
    uniqueWords: !exists(json, 'unique_words')
      ? undefined
      : json['unique_words'],
    eventId: !exists(json, 'event_id') ? undefined : json['event_id'],
    resultId: json['result_id'],
    userId: json['user_id'],
    activityId: json['activity_id'],
    assignmentId: !exists(json, 'assignment_id')
      ? undefined
      : json['assignment_id'],
    assignmentTaskId: !exists(json, 'assignment_task_id')
      ? undefined
      : json['assignment_task_id'],
    isQuest: !exists(json, 'is_quest') ? undefined : json['is_quest'],
    status: WritingStatusFromJSON(json['status']),
    score: !exists(json, 'score') ? undefined : json['score'],
    createdDate: !exists(json, 'created_date')
      ? undefined
      : new Date(json['created_date']),
    updatedDate: !exists(json, 'updated_date')
      ? undefined
      : json['updated_date'] === null
        ? null
        : new Date(json['updated_date']),
    reflection: !exists(json, 'reflection') ? undefined : json['reflection'],
    words: !exists(json, 'words') ? undefined : json['words'],
    userTargetWordCount: !exists(json, 'user_target_word_count')
      ? undefined
      : json['user_target_word_count'],
    userTitle: !exists(json, 'user_title') ? undefined : json['user_title'],
    resultFeedback: !exists(json, 'result_feedback')
      ? undefined
      : json['result_feedback'] === null
        ? null
        : (json['result_feedback'] as Array<any>).map(
            ActivityFeedbackRepresentationFromJSON,
          ),
  }
}

export function ActivityResultSnapshotRepresentationToJSON(
  value?: ActivityResultSnapshotRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activity_result_snapshot_id: value.activityResultSnapshotId,
    unique_words: value.uniqueWords,
    event_id: value.eventId,
    result_id: value.resultId,
    user_id: value.userId,
    activity_id: value.activityId,
    assignment_id: value.assignmentId,
    assignment_task_id: value.assignmentTaskId,
    is_quest: value.isQuest,
    status: WritingStatusToJSON(value.status),
    score: value.score,
    created_date:
      value.createdDate === undefined
        ? undefined
        : value.createdDate.toISOString(),
    updated_date:
      value.updatedDate === undefined
        ? undefined
        : value.updatedDate === null
          ? null
          : value.updatedDate.toISOString(),
    reflection: value.reflection,
    words: value.words,
    user_target_word_count: value.userTargetWordCount,
    user_title: value.userTitle,
    result_feedback:
      value.resultFeedback === undefined
        ? undefined
        : value.resultFeedback === null
          ? null
          : (value.resultFeedback as Array<any>).map(
              ActivityFeedbackRepresentationToJSON,
            ),
  }
}
